export enum AccountType {
    ODP = 'ODP',
    HUB = 'OCP'
}

export enum AppFeature {
  DESTINATION_APP = 'DESTINATION_APP',
  SOURCE_APP = 'SOURCE_APP',
  OPAL_TOOL_APP = 'OPAL_TOOL_APP',
  CMS_UI_EXTENSION_APP = 'CMS_UI_EXTENSION_APP',
}

export enum AppWorksWith {
  CMS = 'CMS',
  OPAL = 'Opal'
}

/**
 * How an app's installations are scoped. Absent/empty means account-level — one installation
 * per account. `CMS` means one installation per CMS instance, keyed by the instance's UUID.
 */
export enum InstallationScopeType {
  CMS = 'CMS'
}

export const OPAL_CATEGORY = 'Opal';

export const categoryDisplayName = (category: string) => (category === OPAL_CATEGORY ? 'Mark' : category);
